import React,{useContext} from "react";
import { Tooltip } from 'react-tippy';
import AuthContext from "../../context/userAuth.context";


export const Morelinks = () => {
  const {
    Access
  } = useContext(AuthContext);
  return (
    <div className="moreOptionsNav">
      <div onClick={() => {

        if (Access != "US2") {
          window.open("https://app.toons.ai/support/", "_blank")
        }
        else {
          window.open("https://app.toons.ai/agencysupport/", "_blank")
        }
      }} className="moreOptionButton">
        <span className="moreOptionIcon iconHoverMoreOption">
          <Tooltip
            title="Contact Support"
            position="top"
            trigger="mouseenter"
            theme='transparent'
            arrow={true}
            animation='scale'
          >
            <span className="material-icons-outlined" style={{ opacity: 0.5 }}>support</span>
          </Tooltip>
        </span>
        Contact Us
      </div>
      <div onClick={() => window.open("https://toons.ai/tutorials/", "_blank")} className="moreOptionButton">
        <span className="moreOptionIcon iconHoverMoreOption">
          <Tooltip
            title="Tutorial Videos"
            position="top"
            trigger="mouseenter"
            theme='transparent'
            arrow={true}
            animation='scale'
          >
            <span className="material-icons-outlined" style={{ opacity: 0.5 }}>airplay</span>
          </Tooltip>
        </span>
        Tutorials
      </div>
    </div>
  );
};

export default Morelinks;
